import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { ControleFacadeService } from "./controle-facade.service";
import {Controle} from "../../models/controle.model";

@Injectable({ providedIn: "root" })
export class ControleStoreService extends EntityStoreService<
  Controle,
  EntityMetadata,
  ControleState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface ControleState extends EntityStoreState<ControleFacadeService> {
}
